var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-progress-linear',{staticStyle:{"pointer-events":"none"},attrs:{"height":"60","color":_vm.progressColor},model:{value:(_vm.timeLeftPercent),callback:function ($$v) {_vm.timeLeftPercent=$$v},expression:"timeLeftPercent"}},[_c('span',{class:[
        'font-weight-bold',
        'text-subtitle-1',
        'white--text'
      ]},[_vm._v(" "+_vm._s(_vm.$t('quoteInfo.timeLeft').toUpperCase())+": "+_vm._s(_vm.formattedTimeLeft)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }